import { isBefore } from 'date-fns';
import { infer as Infer, z } from 'zod';

import { groupPublicSchema } from '#group/groupPublic.schema';
import { locationSchema } from '#location/locationCreate.schema';
import { userPublicSchema } from '#user/userPublic.schema';
import { linkURLRegex } from '#utils/linkURL.regex';

export const calendarUpsertSchema = z
  .object({
    name: z.string().trim().min(1, 'Nazwa jest wymagana'),
    desc: z.string().trim().nullable(),
    type: z.enum(['remote', 'stationary']),
    startDate: z.iso.datetime({ message: 'Data rozpoczęcia jest wymagana' }),
    endDate: z.iso.datetime({ message: 'Data zakończenia jest wymagana' }),
    location: locationSchema.nullable(),
    meetingURL: z.string().regex(linkURLRegex, 'Niepoprawny format linku').nullable(),
    users: z.array(userPublicSchema),
    groups: z.array(groupPublicSchema),
  })
  .refine(
    (value) => {
      const { startDate, endDate } = value;
      return isBefore(startDate, endDate);
    },
    {
      message: 'Czas zakończenia musi być po czasie rozpoczęcia',
      path: ['endDate'],
    }
  );

export type CalendarUpsertSchema = Infer<typeof calendarUpsertSchema>;
